<div
  *ngIf="headerConfig"
  [ngClass]="{'menu-toggle': toggleVal, show: true}"
  [class.iconhover-toggle]="mouseOvered"
>
  <gatewee-wrapper
    [headerConfig]="headerConfig"
    [navigationConfig]="navigationConfig"
  >
    <div
      class="content-wrapper gw-mr-0 gw-my-x-large"
      [class.gw-mt-0]="isDashboard"
      [class.gw-mb-0]="isDashboard"
    >
      <router-outlet></router-outlet>
    </div>
  </gatewee-wrapper>
</div>
